import { ReactElement, useEffect, useState } from "react";
import { wire } from "react-hot-wire";

import { ApplicationService } from "services/application/Application.service";

function InitConfiguration({
  applicationService,
  children
}: {
  applicationService: ApplicationService;
  children: ReactElement;
}) {
  const [render, setRenderState] = useState(false);

  useEffect(() => {
    (async function fetchConfig() {
      await applicationService.fetchConfig();
    })();

    setRenderState(true);
  }, [applicationService]);

  return render ? children : null;
}

export default wire(["applicationService"], InitConfiguration);
